const actions = {
  GET_ORDERS_REQUEST: "GET_ORDERS_REQUEST",
  GET_ORDERS_SUCCESS: "GET_ORDERS_SUCCESS",

  GET_FINISHED_ORDERS_REQUEST: "GET_FINISHED_ORDERS_REQUEST",
  GET_FINISHED_ORDERS_SUCCESS: "GET_FINISHED_ORDERS_SUCCESS",
  GET_FINISHED_ORDER_DETAILS_REQUEST: "GET_FINISHED_ORDER_DETAILS_REQUEST",
  GET_FINISHED_ORDER_DETAILS_SUCCESS: "GET_FINISHED_ORDER_DETAILS_SUCCESS",
  GET_TOP_CUSTOMERS_REQUEST: "GET_TOP_CUSTOMERS_REQUEST",
  GET_TOP_CUSTOMERS_SUCCESS: "GET_TOP_CUSTOMERS_SUCCESS",

  GET_DRIVERS_REQEUST: "GET_DRIVERS_REQEUST",
  GET_DRIVERS_SUCCESS: "GET_DRIVERS_SUCCESS",

  UPDATE_ORDER_DRIVER_REQEUST: "UPDATE_ORDER_DRIVER_REQEUST",
  UPDATE_ORDER_DRIVER_SUCCES: "UPDATE_ORDER_DRIVER_SUCCES",

  DELETE_ORDER_REQEUST: "DELETE_ORDER_REQEUST",
  DELETE_ORDER_SUCCESS: "DELETE_ORDER_SUCCESS",

  UPDATE_DRAG_AND_DROP: "UPDATE_DRAG_AND_DROP",

  TOGGLE_ORDER_INFO: "TOGGLE_ORDER_INFO",
  TOGGLE_READY_ORDERS: "TOGGLE_READY_ORDERS",

  UPDATE_ORDER_STATUS_REQUEST: "UPDATE_ORDER_STATUS_REQUEST",
  UPDATE_ORDER_STATUS_SUCCESS: "UPDATE_ORDER_STATUS_SUCCESS",
  ORDER_UPDATES_STATUS_REQUEST: "ORDER_UPDATES_STATUS_REQUEST",

  TOGGLE_DELIVERY_ENABLED_REQUEST: "TOGGLE_DELIVERY_ENABLED_REQUEST",
  TOGGLE_DELIVERY_ENABLED_SUCCESS: "TOGGLE_DELIVERY_ENABLED_SUCCESS",

  GET_DELIVERY_ENABLED_REQUEST: "GET_DELIVERY_ENABLED_REQUEST",
  GET_DELIVERY_ENABLED_SUCCESS: "GET_DELIVERY_ENABLED_SUCCESS",

  GET_MENU_ITEMS_REQUEST: "GET_MENU_ITEMS_REQUEST",
  GET_MENU_ITEMS_SUCCESS: "GET_MENU_ITEMS_SUCCESS",

  GET_MENU_CATEGORIES_REQUEST: "GET_MENU_CATEGORIES_REQUEST",
  GET_MENU_CATEGORIES_SUCCESS: "GET_MENU_CATEGORIES_SUCCESS",

  GET_ITEM_MODIFIERS_REQUEST: "GET_ITEM_MODIFIERS_REQUEST",
  GET_ITEM_MODIFIERS_SUCCESS: "GET_ITEM_MODIFIERS_SUCCESS",

  GET_CUSTOMER_HISTORY_REQUEST: "GET_CUSTOMER_HISTORY_REQUEST",
  GET_CUSTOMER_HISTORY_SUCCESS: "GET_CUSTOMER_HISTORY_SUCCESS",

  CREATE_ORDER_BY_DISPATCHER_REQUEST: "CREATE_ORDER_BY_DISPATCHER_REQUEST",
  CREATE_ORDER_BY_DISPATCHER_SUCCESS: "CREATE_ORDER_BY_DISPATCHER_SUCCESS",

  TOGGLE_NEW_ORDER_MODAL: "TOGGLE_NEW_ORDER_MODAL",

  SET_LOADING: "SET_LOADING",

  getDeliveryEnabled: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DELIVERY_ENABLED_REQUEST,
      });
    };
  },

  toggleDeliveryEnabled: (newValue) => {
    return (dispatch) => {
      dispatch({
        type: actions.TOGGLE_DELIVERY_ENABLED_REQUEST,
        newValue,
      });
    };
  },

  deleteOrder: (orderId, note) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_ORDER_REQEUST,
        orderId,
        note,
      });
    };
  },

  updateOrderDriver: (orderId, driverId, driverName) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_ORDER_DRIVER_REQEUST,
        orderId,
        driverId,
        driverName,
      });
    };
  },
  getDrivers: (orderId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DRIVERS_REQEUST,
        orderId,
      });
    };
  },

  getOrders: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ORDERS_REQUEST,
      });
    };
  },

  getFinishedOrders: (params) => {
    // params: { startDate, endDate, search, type, status, driver, sortBy, sortOrder, page, pageSize }
    return (dispatch) => {
      dispatch({
        type: actions.GET_FINISHED_ORDERS_REQUEST,
        params,
      });
    };
  },

  getFinishedOrderDetails: (id) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_FINISHED_ORDER_DETAILS_REQUEST,
        id,
      });
    };
  },

  getTopCustomers: (params) => {
    // params: { startDate, endDate, type, limit, sortBy }
    return (dispatch) => {
      dispatch({
        type: actions.GET_TOP_CUSTOMERS_REQUEST,
        params,
      });
    };
  },

  updateDnD: (orders) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_DRAG_AND_DROP,
        orders: orders,
      });
    };
  },

  toggleOrderInfo: (modalOrder) => {
    return (dispatch) => {
      dispatch({
        type: actions.TOGGLE_ORDER_INFO,
        modalOrder: modalOrder,
      });
    };
  },

  toggleReadyOrders: () => {
    return (dispatch) => {
      dispatch({
        type: actions.TOGGLE_READY_ORDERS,
      });
    };
  },

  updateOrderStatus: (order) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_ORDER_STATUS_REQUEST,
        order: order,
      });

      dispatch({
        type: actions.SET_LOADING,
        isLoading: true,
      });
    };
  },

  getMenuItems: (restaurantId, menuType = 2, portalOrganizationId = null) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MENU_ITEMS_REQUEST,
        restaurantId,
        menuType,
        portalOrganizationId,
      });
    };
  },

  getMenuCategories: (restaurantId, menuType = 2, portalOrganizationId = null) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MENU_CATEGORIES_REQUEST,
        restaurantId,
        menuType,
        portalOrganizationId,
      });
    };
  },

  getItemModifiers: (restaurantId, itemId, menuType = 2) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ITEM_MODIFIERS_REQUEST,
        restaurantId,
        itemId,
        menuType,
      });
    };
  },

  getCustomerOrderHistory: (phone, portalOrganizationId = null) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_CUSTOMER_HISTORY_REQUEST,
        phone,
        portalOrganizationId,
      });
    };
  },

  createOrderByDispatcher: (orderData) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_ORDER_BY_DISPATCHER_REQUEST,
        orderData,
      });
    };
  },

  toggleNewOrderModal: () => {
    return (dispatch) => {
      dispatch({
        type: actions.TOGGLE_NEW_ORDER_MODAL,
      });
    };
  },
};
export default actions;
